import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, FormGroup, Input, Label, Row, Spinner } from "reactstrap";
import { setCurrency } from "../../actions/authActions";
import { CurrencyContext } from "../../context/Context";
import { findAllCurrencies } from "../../helpers/api/currency";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import PageHeader from "../common/PageHeader";
import SupportLink from "../root/support/components/SupportLink";
import { fetchAllPages } from "../../helpers/api/pagination";

const CurrencyConfig = () => {
  const dispatch = useDispatch();

  const { currency } = useSelector((state) => state.auth);
  const { loading } = useContext(CurrencyContext);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedCondominium } = useSelector((state) => state.condominium);

  const [params, setParams] = useState({
    condominium_id: selectedCondominium,
  });

  console.log("CURRENCY CONFIG: ", params);

  useEffect(() => {
    if (params) {
      let isMounted = true;
      setIsLoading(true);

      fetchAllPages((page, pageSize) => findAllCurrencies(page, pageSize, params))
        .then(({ data }) => {
          if (isMounted) {
            setData(data);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          if (isMounted) {
            console.log(error);
            handleErrorMessage(error);
            setIsLoading(false);
          }
        });

      return () => {
        isMounted = false;
      };
    }
  }, [params]);

  return (
    <>
      <PageHeader
        title={`Configuración de moneda seleccionada`}
        titleTag="h2"
        description="Selecciona la moneda, esta configuración afecta todos los montos del sistema, configurandola verás la tasa de cambio con la moneda base."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
        <Row form>
          <Col tag={FormGroup}>
            <Label>Moneda seleccionada:</Label>
            {!isLoading ? (
              <Input
                type="select"
                defaultValue={currency}
                onChange={({ target }) => dispatch(setCurrency(target.value))}
                disabled={loading}
              >
              {/*   <option value="" disabled>
                  Selecciona una moneda
                </option> */}
                <option value="" >
                  Selecciona una moneda
                </option>
                {data.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.iso} | {item.name}
                  </option>
                ))}
              </Input>
            ) : (
              <div className="d-block">
                <Spinner size="sm" />
              </div>
            )}
          </Col>
        </Row>
      </PageHeader>
    </>
  );
};

export default CurrencyConfig;
